
import { useState } from 'react';

export default function QuickBookingForm() {
  const [formData, setFormData] = useState({
    flightNumber: '',
    name: '',
    phone: '',
    tripType: '',
    pickupLocation: '',
    customPickupLocation: '',
    dropoffLocation: '',
    customDropoffLocation: '',
    date: '',
    time: '',
    carType: '',
    needWaiting: '',
    waitingDuration: '',
    hospitality: false,
  });

  const carPrices: { [key: string]: number } = {
    'تويوتا هايس': 800,
    'هيونداي ستاريا': 700,
    'تويوتا كامري': 450,
    'فورد تورس': 500,
    'GMC يوكون': 650,
    'تويوتا كوستر': 1200,
    'تويوتا كراون': 550,
  };

  const calculateTotal = () => {
    const basePrice = carPrices[formData.carType] || 0;
    const hospitalityPrice = formData.hospitality ? 50 : 0;
    return basePrice + hospitalityPrice;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const total = calculateTotal();
    const form = e.target as HTMLFormElement;
    const formDataToSend = new FormData(form);
    
    // Add calculated total to form data
    formDataToSend.append('total_price', total.toString());
    formDataToSend.append('base_price', (carPrices[formData.carType] || 0).toString());
    formDataToSend.append('hospitality_price', formData.hospitality ? '50' : '0');
    
    try {
      await fetch('https://readdy.ai/api/form/quick-booking-form-002', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString(),
      });
      
      alert(`تم إرسال طلب الحجز بنجاح!\n\nنوع السيارة: ${formData.carType}\nالسعر الأساسي: ${carPrices[formData.carType]} ريال${formData.hospitality ? '\nالضيافة: 50 ريال' : ''}\nالسعر الإجمالي: ${total} ريال\n\nسنتواصل معك قريباً`);
      
      setFormData({
        flightNumber: '',
        name: '',
        phone: '',
        tripType: '',
        pickupLocation: '',
        customPickupLocation: '',
        dropoffLocation: '',
        customDropoffLocation: '',
        date: '',
        time: '',
        carType: '',
        needWaiting: '',
        waitingDuration: '',
        hospitality: false,
      });
    } catch (error) {
      alert('حدث خطأ في الإرسال، يرجى المحاولة مرة أخرى');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 max-w-4xl mx-auto">
      <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">احجز رحلتك الآن</h3>
      <form id="quick-booking-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">رقم الرحلة</label>
          <input
            type="text"
            name="flightNumber"
            value={formData.flightNumber}
            onChange={handleChange}
            className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="أدخل رقم الرحلة (اختياري)"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">الاسم الكامل</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="أدخل اسمك الكامل"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">رقم الجوال</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="05xxxxxxxx"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">نوع الرحلة</label>
          <select
            name="tripType"
            value={formData.tripType}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent cursor-pointer"
          >
            <option value="">اختر نوع الرحلة</option>
            <option value="ذهاب وعودة">ذهاب وعودة</option>
            <option value="ذهاب فقط">ذهاب فقط</option>
            <option value="عودة فقط">عودة فقط</option>
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">موقع الاستلام</label>
            <select
              name="pickupLocation"
              value={formData.pickupLocation}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent cursor-pointer"
            >
              <option value="">اختر موقع الاستلام</option>
              <option value="من مطار جدة إلى مكة">من مطار جدة إلى مكة</option>
              <option value="من مطار جدة إلى المدينة">من مطار جدة إلى المدينة</option>
              <option value="أخرى">أخرى (يتم التنسيق مع الكابتن)</option>
            </select>
          </div>
          
          {formData.pickupLocation === 'أخرى' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">حدد موقع الاستلام</label>
              <input
                type="text"
                name="customPickupLocation"
                value={formData.customPickupLocation}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="اكتب موقع الاستلام"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">موقع التوصيل</label>
            <select
              name="dropoffLocation"
              value={formData.dropoffLocation}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent cursor-pointer"
            >
              <option value="">اختر موقع التوصيل</option>
              <option value="من مكة إلى مطار جدة">من مكة إلى مطار جدة</option>
              <option value="من مكة إلى المدينة">من مكة إلى المدينة</option>
              <option value="أخرى">أخرى (يتم التنسيق مع الكابتن)</option>
            </select>
          </div>

          {formData.dropoffLocation === 'أخرى' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">حدد موقع التوصيل</label>
              <input
                type="text"
                name="customDropoffLocation"
                value={formData.customDropoffLocation}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="اكتب موقع التوصيل"
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">التاريخ</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">الوقت</label>
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">نوع السيارة</label>
          <select
            name="carType"
            value={formData.carType}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent cursor-pointer"
          >
            <option value="">اختر نوع السيارة</option>
            <option value="تويوتا كامري">تويوتا كامري - 450 ريال</option>
            <option value="فورد تورس">فورد تورس - 500 ريال</option>
            <option value="تويوتا كراون">تويوتا كراون - 550 ريال</option>
            <option value="GMC يوكون">GMC يوكون - 650 ريال</option>
            <option value="هيونداي ستاريا">هيونداي ستاريا - 700 ريال</option>
            <option value="تويوتا هايس">تويوتا هايس - 800 ريال</option>
            <option value="تويوتا كوستر">تويوتا كوستر - 1200 ريال</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">خيار المرابطة</label>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">هل تحتاج مرابطة؟</label>
              <select
                name="needWaiting"
                value={formData.needWaiting}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent cursor-pointer"
              >
                <option value="">اختر</option>
                <option value="نعم">نعم</option>
                <option value="لا">لا</option>
              </select>
            </div>
            
            {formData.needWaiting === 'نعم' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">مدة المرابطة</label>
                <input
                  type="text"
                  name="waitingDuration"
                  value={formData.waitingDuration}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                  placeholder="مثال: 3 ساعات أو يومين"
                />
              </div>
            )}
          </div>
        </div>

        {/* Hospitality Option */}
        <div className="bg-amber-50 rounded-xl p-4 border border-amber-200">
          <h4 className="text-sm font-semibold text-gray-700 mb-3">خدمات إضافية</h4>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              name="hospitality"
              checked={formData.hospitality}
              onChange={handleChange}
              className="mt-1 w-4 h-4 rounded border-2 border-amber-500 text-amber-500 focus:ring-amber-500 cursor-pointer"
            />
            <div className="flex-1">
              <div className="font-medium text-gray-800 text-sm mb-1">
                الضيافة
              </div>
              <div className="text-gray-600 text-xs mb-1">
                قهوة عربية + تمر
              </div>
              <div className="font-semibold text-amber-600 text-sm">
                +50 ريال
              </div>
            </div>
            <div className="w-10 h-10 flex items-center justify-center bg-white rounded-lg border border-amber-200">
              <i className="ri-cup-fill text-amber-500 text-lg"></i>
            </div>
          </label>
        </div>

        {/* Price Summary */}
        {formData.carType && (
          <div className="bg-amber-50 rounded-xl p-4 border-2 border-amber-300">
            <h4 className="font-semibold text-gray-800 mb-3 text-sm">ملخص السعر</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">سعر السيارة ({formData.carType})</span>
                <span className="font-semibold text-gray-800">{carPrices[formData.carType]} ريال</span>
              </div>
              {formData.hospitality && (
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">الضيافة</span>
                  <span className="font-semibold text-gray-800">50 ريال</span>
                </div>
              )}
              <div className="border-t border-amber-300 pt-2 mt-2">
                <div className="flex items-center justify-between">
                  <span className="font-bold text-gray-800">الإجمالي</span>
                  <span className="font-bold text-amber-600 text-xl">{calculateTotal()} ريال</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <button
          type="submit"
          className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-4 rounded-lg font-bold text-lg hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          احجز الآن
        </button>
      </form>
    </div>
  );
}
